import createPersistedState from 'vuex-persistedstate'

export default ({ store }) => {
    createPersistedState({
        storage: window.localStorage  // 改用 localStorage 替代 sessionStorage
    })(store)
}